/** `3:54` for 234 seconds. Whole seconds, rounded up, so a limit never reads shorter than it is. */
export function clockLabel(totalSeconds: number): string {
  const whole = Math.max(Math.ceil(totalSeconds), 0);
  const minutes = Math.floor(whole / 60);
  const seconds = whole % 60;
  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
}
